export const SENSITIVE_DATA_BRANDED_TYPE: string = '\u200B\u200B';
